import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export const PAGE_CONTAINER_SX = {
	width: '100%',
	maxWidth: { xs: '100%', lg: 1200 },
	mx: 'auto',
	pb: { xs: 10, sm: 8 },
};

export const PreviewPanel = ({ title, action, children }) => (
	<Paper
		variant="outlined"
		sx={{
			p: { xs: 2, sm: 2.5 },
			bgcolor: 'action.hover',
			borderStyle: 'dashed',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
		}}
	>
		<Stack
			direction={{ xs: 'column', sm: 'row' }}
			alignItems={{ xs: 'stretch', sm: 'flex-start' }}
			justifyContent="space-between"
			spacing={1.25}
			sx={{ mb: 1.5 }}
		>
			<Typography
				variant="overline"
				color="text.secondary"
				sx={{ letterSpacing: 1, lineHeight: 1.4 }}
			>
				{title}
			</Typography>
			{action}
		</Stack>
		<Box
			sx={{
				flex: 1,
				p: { xs: 2, sm: 2.5 },
				bgcolor: 'background.paper',
				borderRadius: 1.5,
				border: 1,
				borderColor: 'divider',
				minHeight: { xs: 88, sm: 112 },
			}}
		>
			{children}
		</Box>
	</Paper>
);

export const SectionHeader = ({
	icon: Icon,
	title,
	description,
	titleAdornment,
}) => (
	<Stack
		direction={{ xs: 'column', sm: 'row' }}
		spacing={{ xs: 1.5, sm: 2 }}
		alignItems={{ xs: 'flex-start', sm: 'center' }}
		sx={{ mb: { xs: 2.5, sm: 3 } }}
	>
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: 44,
				height: 44,
				borderRadius: 2,
				bgcolor: 'action.hover',
				color: 'primary.main',
				flexShrink: 0,
			}}
		>
			<Icon fontSize="small" />
		</Box>
		<Box sx={{ minWidth: 0 }}>
			<Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
				<Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
					{title}
				</Typography>
				{titleAdornment}
			</Stack>
			<Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
				{description}
			</Typography>
		</Box>
	</Stack>
);

export const SectionCard = ({ id, children }) => (
	<Box
		id={id}
		sx={{
			border: 1,
			borderColor: 'divider',
			borderRadius: 2,
			bgcolor: 'background.paper',
			p: { xs: 2, sm: 3 },
		}}
	>
		{children}
	</Box>
);
